import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
const names = ['Camila', 'Rodrigo', 'Sofía', 'Matías', 'Florencia', 'Nicolás', 'Valentina', 'Agustín', 'Mariana', 'Tomás', 'Lucía', 'Diego', 'Carolina', 'Martín'];
const cities = ['Buenos Aires', 'Bogotá', 'Lima', 'Santiago', 'Montevideo', 'Medellín', 'Quito', 'Córdoba', 'Rosario', 'CDMX', 'Mendoza', 'La Plata', 'Tucumán'];
export const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 14) + 2;
      setData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
    };
    // First popup after 10 seconds, then every 30 seconds
    const initialTimer = setTimeout(() => {
      triggerPopup();
      const interval = setInterval(triggerPopup, 30000);
      return () => clearInterval(interval);
    }, 10000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-319">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} className="fixed bottom-20 md:bottom-6 left-4 md:left-6 z-50 bg-night-800 border border-night-700 shadow-2xl rounded-lg p-4 max-w-[280px] md:max-w-xs flex items-start gap-3" data-id="element-320">
          <div className="bg-cta/20 p-2 rounded-full shrink-0" data-id="element-321">
            <ShoppingCart className="w-5 h-5 text-cta" data-id="element-322" />
          </div>
          <div data-id="element-323">
            <p className="text-sm text-gray-200 leading-tight" data-id="element-324">
              <span className="font-bold text-white" data-id="element-325">{data.name}</span> de{' '}
              {data.city} compró este libro digital
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-326">
              hace {data.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};